import React from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  FormGroup,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { addTips } from "store/actions/settingAction";

const AddTipModal = ({ addModal, addToggle }) => {
  const dispatch = useDispatch();
  const { uid, user } = useSelector((state) => state.auth);
  const { tipLoader } = useSelector((state) => state.setting);
  const [value, setValue] = useState("");

  const handleSubmit = (evt) => {
    evt.preventDefault();
    dispatch(
      addTips(uid, value, () => {
        addToggle();
        setValue("");
      })
    );
  };

  const handleCancelToggle = () => {
    setValue("");
    addToggle();
  };

  const handleModalClick = (e) => {
    if (e.target.closest(".modal-content")) {
      return;
    }
    addToggle();
  };

  const handleChange = (e) => {
    const inputValue = e.target.value.replace(/[^0-9.]/g, "");
    setValue(inputValue);
  };

  return (
    <div>
      <Modal isOpen={addModal} toggle={handleCancelToggle} onClick={handleModalClick}>
        <ModalHeader toggle={handleCancelToggle} >
          Add Tip{" "}
        </ModalHeader>
        <ModalBody className="pt-0">
          <Form onSubmit={handleSubmit}>
            <FormGroup>
              <Label>Enter Tip </Label>
              <div>
                <Input
                  type="number"
                  step="any"
                  min={0}
                  value={value}
                  placeholder={`Enter amount (${user.currency})`}
                  onChange={handleChange}
                />
              </div>
            </FormGroup>
            <div className="d-flex justify-content-end">
              <Button
                color="primary"
                type="submit"
                disabled={tipLoader || !value}
              >
                {tipLoader ? <Spinner size="sm" /> : "Add"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default AddTipModal;
